export const color = {
    primary:"#007cba",
    white:"#fff",
    black:"rgba(0,0,0,1)"
}